module.exports = __webpack_public_path__ + "static/media/fns-swiss-logo.fd3e950a.svg";